import AiContextRelationships from '../../js/db/AiContextRelationships.js';
import AiContextQueryRules from '../../js/db/AiContextQueryRules.js';
import AiContextExamples from '../../js/db/AiContextExamples.js';
import AiContextPromptRules from '../../js/db/AiContextPromptRules.js';

export const AI_CONTEXT_CONFIG = {
  relationships: {
    key: 'relationships',
    title: 'Relationships',
    singular: 'relationship',
    routeBase: '/agenteia/relationships/',
    permissionBase: 'agenteia/relationships',
    tableCode: 'AIRELATIONSHIPS',
    dbAdapter: AiContextRelationships,
    type: 'text'
  },
  queryRules: {
    key: 'queryRules',
    title: 'Query Rules',
    singular: 'query rule',
    routeBase: '/agenteia/queryrules/',
    permissionBase: 'agenteia/queryrules',
    tableCode: 'AIQUERYRULES',
    dbAdapter: AiContextQueryRules,
    type: 'text'
  },
  examples: {
    key: 'examples',
    title: 'Examples',
    singular: 'example',
    routeBase: '/agenteia/examples/',
    permissionBase: 'agenteia/examples',
    tableCode: 'AIEXAMPLES',
    dbAdapter: AiContextExamples,
    type: 'example'
  },
  promptRules: {
    key: 'promptRules',
    title: 'Prompt Rules',
    singular: 'prompt rule',
    routeBase: '/agenteia/promptrules/',
    permissionBase: 'agenteia/promptrules',
    tableCode: 'AIPROMPTRULES',
    dbAdapter: AiContextPromptRules,
    type: 'text'
  }
};

export function getAiContextConfig(contextType) {
  return AI_CONTEXT_CONFIG[contextType];
}

/**
 * Tags predefinidos de los documentos de IA.
 *
 * No son decorativos: el motor de auditoría (DT-AUD) recupera el contexto normativo
 * filtrando por tag en Qdrant, y ese filtro distingue mayúsculas. Por eso el valor
 * tiene que ser siempre el mismo literal, y por eso se ofrecen desde aquí en vez de
 * dejarlos a texto libre. Para añadir uno nuevo, basta con ponerlo en esta lista.
 */
export const TAGS_DOCUMENTOS = [
  'NORMATIVA'
];
